<template>
  <div class="relative w-full h-full">
    <Image :src="colorTileImage" alt="Colorpicker" img-classes="object-cover bg-white" class="w-full h-full" />
    <input
      type="color"
      v-model="color"
      class="absolute top-0 left-0 cursor-pointer w-full h-full"
      @input="onColorInput"
      @focus="onColorComplete"
    />
  </div>
</template>

<script setup lang="ts">
import colorTileImage from "@public/images/colorTile.png";
import { Image } from "prism";
import { ref } from "vue";
import debounce from "lodash.debounce";

const color = ref("#0000FF");

const emit = defineEmits<{
  (e: "colorPickerChanged", color: string): void;
  (e: "colorPickerChangeComplete", color: string): void;
}>();

// Emits the event continuously as the color changes
const onColorInput = () => {
  emit("colorPickerChanged", color.value);
  debouncedEmitColorComplete();
};

const onColorComplete = () => {
  emit("colorPickerChangeComplete", color.value);
};

const debouncedEmitColorComplete = debounce(() => {
  onColorComplete();
}, 300);
</script>

<style lang="css" scoped>
input[type="color"] {
  opacity: 0;
  display: block;
  border: none;
}
</style>
